/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const cog = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M18.4 12c0-.5 0-.9-.1-1.3l1.4-1.3-1.5-2.8-1.8.6c-.6-.6-1.4-1-2.2-1.3L13.8 4h-3l-.4 1.9c-.8.3-1.5.8-2.1 1.3l-1.8-.6L5 9.4l1.4 1.3c-.1.4-.1.9-.1 1.3s0 .9.1 1.3L5 14.6l1.5 2.8 1.8-.6c.6.6 1.4 1 2.2 1.3l.4 1.9h3l.4-1.9c.8-.3 1.5-.7 2.2-1.3l1.8.6 1.5-2.8-1.4-1.3c-.1-.4 0-.8 0-1.3zm-6.1 3.2c-1.7 0-3-1.4-3-3.2 0-1.8 1.4-3.2 3-3.2 1.7 0 3 1.4 3 3.2.1 1.8-1.3 3.2-3 3.2z" />
	</SVG>
);

export default cog;
